import React from 'react';
import classes from "../../Landing/Landing.module.scss";
import { Button, Grid } from '@mui/material';
// --- SVG Icon Components ---
// Using inline SVGs to keep everything in one file.

const ToothIcon = ({ className }) => (
  <img className={className} src="https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1767077705/root_canal_hxzthz.png" alt="Root canal and dental implant icon" />
);

const CrownIcon = ({ className }) => (
  <img className={className} src="https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1767077701/veneer_wvv69x.png" alt="Dental crown and veneer icon" />
);

const BracesIcon = ({ className }) => (
  <img className={className} src="https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1767077703/braces_pvrahg.png" alt="Dental braces and aligners icon" />
);

const LaserIcon = ({ className }) => (
  <img className={className} src="https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1767077703/laser_fhm5ua.png" alt="Laser and veneer treatments icon" />
);

const BuildingIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 11V5H10V11H16M16 3H10C8.9 3 8 3.9 8 5V11C8 12.1 8.9 13 10 13H16C17.1 13 18 12.1 18 11V5C18 3.9 17.1 3 16 3M6 13H2V21H6V13M6 11H2C0.9 11 0 11.9 0 13V21C0 22.1 0.9 23 2 23H6C7.1 23 8 22.1 8 21V13C8 11.9 7.1 11 6 11M22 13H18V21H22V13M22 11H18C16.9 11 16 11.9 16 13V21C16 22.1 16.9 23 18 23H22C23.1 23 24 22.1 24 21V13C24 11.9 23.1 11 22 11Z" />
  </svg>
);


// --- Hero Section Component ---

const HomeBanner = () => {
  const services = [
    { name: 'Implants & Root Canals', icon: <ToothIcon className="w-6 h-6 text-[#88B121]" /> },
    { name: 'Aligners & Braces', icon: <BracesIcon className="w-6 h-6 text-[#88B121]" /> },
    { name: 'Crown & Bridges', icon: <CrownIcon className="w-6 h-6 text-[#88B121]" /> },
    { name: 'Lasers & Veneers', icon: <LaserIcon className="w-6 h-6 text-[#88B121]" /> },
  ];

  return (
    <section className="bg-white font-['Inter',_sans-serif] py-10 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          
          {/* --- Left Column: Text Content --- */}
            <div className="lg:w-1/2 max-w-lg text-center lg:text-left flex flex-col items-center lg:items-start">
            <h1 className="text-4xl sm:text-5xl  font-bold text-slate-800 leading-tight">
              Advanced Dental Care
              <span className=" block text-[#88B121]"><strong>Trusted Smiles</strong></span>
            </h1>
            <p className="mt-3 text-gray-600 text-lg"  aria-label="Trusted by 2000+ Patients in Gandhinagar">
              Trusted by <span className="font-bold text-gray-800">2000+ Patients</span>
            </p>
            <h1 className="sr-only">Dental Clinic in Gandhinagar | Best Dentist in Gandhinagar | Dental Clinic Near Me,</h1>

            <div className="mt-6 grid grid-cols-2 gap-x-4 gap-y-3 max-w-sm">
              {services.map((service) => (
                <div key={service.name} className="flex items-center space-x-2">
                  <span className="flex items-center space-x-2">
                    {service.icon}
                  </span>
                  <span className="text-gray-700  text-sm font-medium">{service.name}</span>
                </div>
              ))}
            </div>

            <a
              href="/appointmentpage"
              className="mt-8 inline-block bg-[#88B121] text-white font-bold text-sm uppercase tracking-wider py-4 px-8 rounded-full shadow-lg hover:bg-lime-600 transition-colors duration-300"
            >
              Book An Appointment
            </a>
          </div>

          {/* --- Right Column: Image & Badges --- */}
          <div className="lg:w-1/2 flex justify-center">
        <img
          src="https://res.cloudinary.com/dflcuzluo/image/upload/f_auto,q_auto/v1767162721/drpragnesh_y7eqa9.png"
          alt="Dr. Pragnesh Solanki - Best Dentist at Mahi Dental Clinic Gandhinagar"
          fetchpriority="high"
          className="max-w-sm w-full h-auto rounded-full object-cover"
          onError={(e) => {
            e.target.src =
              "https://placehold.co/500x600/E0E0E0/777777?text=Image+Not+Found";
          }}
        />
      </div>

              {/* 20 Years Badge */}
              {/* <div className="absolute  bottom-4 left-1/2 -translate-x-1/2 lg:left-0 lg:bottom-12 lg:-translate-x-1/4 w-auto">
                <div className="bg-white rounded-xl shadow-xl p-3 sm:p-4 flex items-center space-x-3">
                  <div className="flex-shrink-0 bg-lime-500 text-white p-2 sm:p-3 rounded-full">
                    <ToothIcon className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <div className="text-gray-800 font-bold text-base sm:text-lg whitespace-nowrap">
                    20 Years of Experience
                  </div>
                </div>
              </div> */}

              {/* 13 Branches Badge */}
              {/* <div className="absolute  top-1/2 -translate-y-1/2 right-0 lg:-right-4 w-auto">
                 <div className="bg-indigo-900 text-white rounded-xl shadow-xl p-3 sm:p-4 flex items-center space-x-3">
                  <div className="flex-shrink-0">
                    <BuildingIcon className="w-7 h-7 sm:w-8 sm:h-8" />
                  </div>
                  <div>
                    <div className="font-semibold text-base sm:text-lg whitespace-nowrap">13 Braches</div>
                    <div className="text-sm sm:text-base whitespace-nowrap">4 Cities</div>
                  </div>
                </div>
              </div> */}

            </div>
          </div>

    </section>
  );
};
export default HomeBanner;